import Heading from '../components/heading/heading';
import React, { useEffect, useState } from 'react';
import { Radio, message } from 'antd';
import Cookies from 'js-cookie';
import axios from '../backendService';
import ScheduleNewLectureForm from '../components/video-components/ScheduleNewLectureForm';
import RescheduleLectureForm from '../components/video-components/RescheduleLectureForm';

const ScheduleNewLecture = () => {
  const userId = Cookies.get('userId'); // Get user ID from cookies

  // States for course, batch, and user videos data
  const [courseData, setCourseData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [userVideos, setUserVideos] = useState([]);
  const [courseLoading, setCourseLoading] = useState(false);
  const [radioValue, setRadioValue] = useState(1); // Radio state for toggling between forms

  const fetchCourseData = async () => {
    try {
      setCourseLoading(true);
      const response = await axios.get(`/users/getUserCourseData/${userId}`);
      const resData = await response.data.courses;
      setCourseData(resData);
      const userVideos = await response.data.userVideos.sort(
        (a, b) => new Date(`${b.publishDate} ${b.startTime}`) - new Date(`${a.publishDate} ${a.startTime}`),
      );
      setUserVideos(userVideos);
      setCourseLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchCourseData();
  }, []);
  // Handle radio change for toggling forms
  const onRadioChange = (e) => {
    setRadioValue(e.target.value);
  };

  return (
    <div className="min-h-screen w-screen bg-white z-10">
      <Heading as="h4" className="text-dark dark:text-white87 text-[22px] font-semibold pt-10 px-6">
        {radioValue === 1 ? 'Schedule new lecture' : 'Reschedule a lecture'}
      </Heading>
      <div className="px-6 pt-5 pb-20">
        {/* Radio Group for toggling forms */}
        <Radio.Group onChange={onRadioChange} value={radioValue} className="mb-7">
          <Radio value={1}>Upload a new lecture</Radio>
          <Radio value={2}>Reschedule lecture from personal video pool</Radio>
          <Radio disabled value={3}>
            Reschedule lecture from global video pool
          </Radio>
        </Radio.Group>

        {/* Conditional rendering of forms */}
        {radioValue === 1 && (
          <ScheduleNewLectureForm courseData={courseData} batchData={batchData} courseLoading={courseLoading} />
        )}
        {radioValue === 2 && (
          <RescheduleLectureForm
            // courseData={courseData}
            // batchData={batchData}
            courseLoading={courseLoading}
            userVideos={userVideos}
            // fetchCourseData={fetchCourseData} // Pass fetch function for refreshing
          />
        )}
      </div>
    </div>
  );
};

export default ScheduleNewLecture;
